import React from 'react';
import classNames from 'classnames';
import { LiveBlogModalView } from '../../state/types';

interface Props {
  title: string;
  showNavigation: boolean;
  view: LiveBlogModalView;
  onViewChange: (view: LiveBlogModalView) => void;
}

export const navigationItems: LiveBlogModalView[] = [
  LiveBlogModalView.EventDetails,
  LiveBlogModalView.Team,
  LiveBlogModalView.EmbedCode
];

const ModalHeader: React.FC<Props> = ({ title, showNavigation, view, onViewChange }) => {
  const onTabItemClick = (tab: LiveBlogModalView) => {
    return () => (view === tab ? () => {} : onViewChange(tab));
  };

  return (
    <div className={'header'}>
      <h4 className={'title'}>{title}</h4>
      {showNavigation && (
        <div className={'secondary-navigation'}>
          <div className="navigation">
            {navigationItems.map(label => (
              <a
                key={label}
                className={classNames('secondary-item', label === view && 'selected')}
                onClick={onTabItemClick(label)}
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ModalHeader;
